import ModalSection from "@hl/base-components/lib/modal/ModalSection";
import {
  DESTRUCTIVE_COLOR,
  SECONDARY_COLOR,
} from "@hl/base-components/lib/theme/button";
import { Button, Group, Modal, Text } from "@mantine/core";

export interface ConditionDeleteModalProps {
  onClose: () => void;
  onConfirm: () => void;
}

const RemoveConditionModal = ({
  onClose,
  onConfirm,
}: ConditionDeleteModalProps) => {
  return (
    <Modal
      size="lg"
      opened={true}
      title={
        <Text size="lg" weight={500}>
          Delete condition
        </Text>
      }
      withCloseButton={false}
      onClose={onClose}
    >
      <div>
        <Text size={"sm"}>
          Are you sure you want to delete this condition?{" "}
        </Text>
        <ModalSection>
          <Group noWrap>
            <Button
              fullWidth
              color={SECONDARY_COLOR}
              size="xl"
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              fullWidth
              color={DESTRUCTIVE_COLOR}
              size="xl"
              onClick={onConfirm}
            >
              Delete condition
            </Button>
          </Group>
        </ModalSection>
      </div>
    </Modal>
  );
};

export default RemoveConditionModal;
